import { Form, Input, Modal, Select, message } from "antd";
import { useEffect, useMemo, useState } from "react";
import { createBankAccount } from "../../../../api/bankAccountApi";
import { getCurrencies } from "../../../../api/institutionApi";
import { BANK_OPTIONS } from "./bankAccountConstants";

export default function BankAccountCreateModal({
  open,
  institutionId,
  institutionName,
  onClose,
  onSuccess,
}) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const [currencies, setCurrencies] = useState([]);
  const [loadingCurrencies, setLoadingCurrencies] = useState(false);

  useEffect(() => {
    if (!open) return;

    let mounted = true;

    async function loadCurrencies() {
      try {
        setLoadingCurrencies(true);
        const data = await getCurrencies();
        if (!mounted) return;
        setCurrencies(Array.isArray(data) ? data : []);
      } catch (error) {
        message.error("Валютын жагсаалт ачааллахад алдаа гарлаа");
      } finally {
        if (mounted) {
          setLoadingCurrencies(false);
        }
      }
    }

    loadCurrencies();

    return () => {
      mounted = false;
    };
  }, [open]);

  const currencyOptions = useMemo(() => {
    return (currencies || []).map((item) => ({
      label: item.code || item.name || String(item.id),
      value: item.id,
    }));
  }, [currencies]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      setSubmitting(true);

      await createBankAccount({
        institutionId,
        bank: values.bank,
        accountNumber: values.accountNumber?.trim(),
        currencyId: values.currencyId,
      });

      message.success("Данс амжилттай үүслээ");
      form.resetFields();
      onSuccess?.();
      onClose?.();
    } catch (error) {
      if (error?.errorFields) return;
      message.error(
        error?.response?.data?.message || "Данс үүсгэхэд алдаа гарлаа"
      );
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose?.();
  };

  return (
    <Modal
      title={`Данс нэмэх${institutionName ? ` - ${institutionName}` : ""}`}
      open={open}
      onCancel={handleCancel}
      onOk={handleSubmit}
      okText="Үүсгэх"
      cancelText="Болих"
      confirmLoading={submitting}
      destroyOnHidden
    >
      <Form form={form} layout="vertical">
        <Form.Item label="Байгууллага">
          <Input value={institutionName || ""} disabled />
        </Form.Item>

        <Form.Item
          label="Банк"
          name="bank"
          rules={[{ required: true, message: "Банк сонгоно уу" }]}
        >
          <Select
            showSearch
            options={BANK_OPTIONS}
            placeholder="Банк сонгох"
            optionFilterProp="label"
          />
        </Form.Item>

        <Form.Item
          label="Дансны дугаар"
          name="accountNumber"
          rules={[
            { required: true, message: "Дансны дугаар оруулна уу" },
            { min: 6, message: "Хэт богино байна" },
            { max: 50, message: "Хэт урт байна" },
          ]}
        >
          <Input placeholder="Жишээ: 1234567890" maxLength={50} />
        </Form.Item>

        <Form.Item
          label="Валют"
          name="currencyId"
          rules={[{ required: true, message: "Валют сонгоно уу" }]}
        >
          <Select
            loading={loadingCurrencies}
            options={currencyOptions}
            placeholder="Валют сонгох"
            optionFilterProp="label"
            showSearch
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}